export type CameraPermissionStatus =
  | 'granted'
  | 'not-determined'
  | 'denied'
  | 'restricted';
export type CameraPermissionRequestResult = 'granted' | 'denied';
export type CameraPosition = 'front' | 'back' | 'external';
export type PhysicalCameraDeviceType =
  | 'ultra-wide-angle-camera'
  | 'wide-angle-camera'
  | 'telephoto-camera';

export interface Code {
  corners?: Array<{ x: number; y: number }>;
  frame?: {
    height: number;
    width: number;
    x: number;
    y: number;
  };
  type: string | 'unknown';
  value?: string;
}

const CameraComponent = () => null;

// Add static methods for use-request-camera to return granted
// to avoid denied permissions toasts on web
CameraComponent.getCameraPermissionStatus = (): CameraPermissionStatus => {
  return 'granted';
};
CameraComponent.requestCameraPermission = async () => {
  return 'granted';
};

export const Camera = CameraComponent;
export const useCameraDevice = () => null;
export const useCameraDevices = () => ({ back: null, front: null });
export const useCameraFormat = () => null;
export const useCodeScanner = () => null;

export default {
  Camera,
  useCameraDevice: () => null,
  useCameraDevices,
  useCameraFormat,
  useCodeScanner,
};
